module.exports = __webpack_public_path__ + "img/item8.8d762b91.png";